class FloatingNav extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.footer?.exists) return

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px',
      threshold: 0,
    })

    this.observer.observe(this.externalEls.footer.element)
  }

  onEntry ([entry], observer) {
    this.setAttribute('aria-hidden', entry.isIntersecting)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}

if (!customElements.get('floating-nav')) {
  customElements.define('floating-nav', FloatingNav)
}
